<template>
  <div class="repetitor-catalog v2-container-small">
    <h1>{{ titleByFilter }}</h1>

    <button
      :class="`m-btn tablet repetitor-catalog__mob-btn repetitor-catalog__mob-btn--${filCount}`"
      @click="openMobileFilter"
    >
      <img
        src="/v2/catalog/repetitor/catalog/filter-icon.svg"
        alt="filter"
      >
    </button>

    <repetitor-catalog-filters
      ref="catalogFilters"
      :subject.sync="subject"
      :grade.sync="grade"
      :target.sync="target"
    />

    <repetitor-catalog-banner
      @open-free-modal="$emit('open-free-modal')"
    />

    <template v-for="(card, index) in paginationCards">
      <repetitor-catalog-card-free
        v-if="card.free"
        :key="index"
        :card="card"
        @open-free-modal="$emit('open-free-modal', card)"
      />
      <repetitor-catalog-card
        v-else
        :key="`free-${index}`"
        :card="card"
        @open-free-modal="$emit('open-free-modal', card)"
      />
    </template>

    <button
      v-if="showMoreCount > 0"
      class="repetitor-catalog__more-btn m-btn"
      @click="showMore"
    >
      <span>Открыть еще 10 репетиторов из {{ showMoreCount }}</span>
      <img
        src="/v2/catalog/repetitor/catalog/arrow-down.svg"
        alt="down"
      >
    </button>
  </div>
</template>

<script>
import RepetitorCatalogFilters from './RepetitorCatalogFilters.vue';
import RepetitorCatalogBanner from './RepetitorCatalogBanner.vue';
import RepetitorCatalogCard from './RepetitorCatalogCard.vue';

import catalogCards, { subjectList, gradeList, targetList } from './repetitorCards';
import RepetitorCatalogCardFree from './RepetitorCatalogCardFree.vue';

export default {
  name: 'RepetitorCatalog',
  components: {
    RepetitorCatalogCardFree,
    RepetitorCatalogCard,
    RepetitorCatalogBanner,
    RepetitorCatalogFilters,
  },
  data: () => ({
    subject: 'all',
    grade: 'all',
    target: 'all',
    showCount: 10,
  }),
  computed: {
    filteredCards() {
      let filteredCards = [...catalogCards];

      if (this.subject !== 'all') {
        filteredCards = filteredCards.filter(({ subject, free }) => subject === this.subject || free);
      }

      if (this.grade !== 'all') {
        const grade = parseInt(this.grade, 10);
        filteredCards = filteredCards.filter(({ classes, free }) => (
          (classes && grade >= classes.from && grade <= classes.to) || free
        ));
      }

      if (this.target !== 'all') {
        filteredCards = filteredCards.filter(({ cheap }) => cheap.some((ch) => ch.id === this.target));
      }

      this.setPathWithFilters();

      return filteredCards;
    },
    paginationCards() {
      return this.filteredCards.slice(0, this.showCount);
    },
    showMoreCount() {
      return this.filteredCards.length - this.showCount;
    },

    titleByFilter() {
      let title = 'репетиторы';
      if (this.subject !== 'all') {
        title += ` по ${subjectList.find(({ id }) => id === this.subject).forTitle}`;
      }
      if (this.grade !== 'all') {
        title += ` для ${gradeList.find(({ id }) => id === this.grade).title}а`;
      }
      if (this.target !== 'all') {
        title += `, ЧТОБЫ ${targetList.find(({ id }) => id === this.target).forTitle}`;
      }

      return title;
    },
    filCount() {
      let count = 0;
      if (this.subject !== 'all') count += 1;
      if (this.grade !== 'all') count += 1;
      if (this.target !== 'all') count += 1;
      return count;
    },
  },
  watch: {
    filteredCards() {
      this.showCount = 10;
    },
    subject() {
      this.$emit('subject', this.subject === 'all' ? null : this.subject);
    },
    grade() {
      this.$emit('grade', this.grade === 'all' ? null : this.grade);
    },
    target() {
      this.$emit('target', this.target === 'all' ? null : this.target);
    },
  },
  mounted() {
    const { first, second, third } = this.$route.params;
    if (first) {
      if (subjectList.some(({ id }) => id === first)) this.subject = first;
      if (gradeList.some(({ id }) => id === first)) this.grade = first;
      if (targetList.some(({ id }) => id === first)) this.target = first;
    }
    if (second) {
      if (gradeList.some(({ id }) => id === second)) this.grade = second;
      if (targetList.some(({ id }) => id === second)) this.target = second;
    }
    if (third) {
      if (targetList.some(({ id }) => id === third)) this.target = third;
    }
  },
  methods: {
    showMore() {
      this.showCount += 10;
    },
    setPathWithFilters() {
      let path = '';
      if (this.subject !== 'all') path += `/${this.subject}`;
      if (this.grade !== 'all') path += `/${this.grade}`;
      if (this.target !== 'all') path += `/${this.target}`;

      this.$router.push({ path: `/catalog/repetitor${path}`, query: this.$route.query });
    },
    openMobileFilter() {
      this.$refs.catalogFilters.mobileFilter = true;
    },
  },
};
</script>

<style scoped lang="scss">

.repetitor-catalog {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @include media-down(tablet) {
    gap: 12px;
  }

  h1 {
    font-weight: 700;
    font-size: 45px;
    line-height: 110%;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    font-feature-settings: 'case' on;
    color: $black;

    @include media-down(tablet) {
      padding-left: 8px;
      font-size: 30px;
      margin-bottom: 4px;
    }
  }

  &__mob-btn {
    position: sticky;
    width: 44px;
    height: 44px;
    top: calc(var(--scale) * 80);
    z-index: 5;
    margin-left: auto;
    margin-top: -44px;
    transform: translateY(49px);

    background-color: $gray-bg;
    border-radius: 20px;

    &::after {
      position: absolute;
      width: 12px;
      height: 12px;
      right: 6px;
      top: 4px;
      background-color: #FA5019;
      border-radius: 50%;
      outline: 1px solid #F6F6F6;

      font-weight: 900;
      font-size: 9px;
      line-height: 100%;
      display: grid;
      place-content: center;
      color: $white-color;
    }

    &--1::after {
      content: '1';
    }

    &--2::after {
      content: '2';
    }

    &--3::after {
      content: '3';
    }
  }

  &__more-btn {
    width: fit-content;
    margin-inline: auto;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 29px 18px;
    border: 1px solid rgba($black, 0.2);
    border-radius: 200px;
    transition: 200ms;

    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: $black;

    @include media-down(tablet) {
      margin-top: 12px;
      padding: 13px 23px 15px;

      font-size: 14px;
      line-height: 130%;
    }

    &:hover {
      border-color: $black;
    }
  }
}

</style>
